import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import { EnergyCost } from '../Energy';
import { energySymbols } from '../Energy/energySymbols';
import { EnergyList } from './styled';

const Energies = ({ energyAttachments }) => {
  if (!energyAttachments.size) {
    return <div>No energy attached</div>;
  }

  return (
    <EnergyList>
      {energyAttachments.map(energy => (
        <li key={energy.get('id')}>
          <EnergyCost types={energySymbols(List([energy])).toJS()} />
          {energy.getIn(['card', 'name'])}
        </li>
      ))}
    </EnergyList>
  );
};

Energies.propTypes = {
  energyAttachments: PropTypes.instanceOf(List).isRequired,
};

export default Energies;
